export function Spinner(props: React.ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 200 200"
      aria-hidden="true"
      {...props}
    >
      <radialGradient
        id="a12"
        cx=".66"
        fx=".66"
        cy=".3125"
        fy=".3125"
        gradientTransform="scale(1.5)"
      >
        <stop offset="0" stopColor="currentColor" stopOpacity="0" />
        <stop offset=".3" stopColor="currentColor" stopOpacity=".3" />
        <stop offset=".6" stopColor="currentColor" stopOpacity=".6" />
        <stop offset=".8" stopColor="currentColor" stopOpacity=".9" />
        <stop offset="1" stopColor="currentColor" />
      </radialGradient>
      <circle
        fill="none"
        stroke="url(#a12)"
        strokeWidth="15"
        strokeLinecap="round"
        strokeDasharray="200 1000"
        strokeDashoffset="0"
        cx="100"
        cy="100"
        r="70"
        style={{ transformOrigin: "center" }}
      >
        <animateTransform
          type="rotate"
          attributeName="transform"
          calcMode="spline"
          dur="1"
          values="0;360"
          keyTimes="0;1"
          keySplines="0 0 1 1"
          repeatCount="indefinite"
        />
      </circle>
      <circle
        fill="none"
        opacity=".1"
        stroke="currentColor"
        strokeWidth="15"
        strokeLinecap="round"
        cx="100"
        cy="100"
        r="70"
      />
    </svg>
  );
}
